import { render, staticRenderFns } from "./samplePointDetail.vue?vue&type=template&id=4414f044&scoped=true&"
import script from "./samplePointDetail.vue?vue&type=script&lang=js&"
export * from "./samplePointDetail.vue?vue&type=script&lang=js&"
import style0 from "./samplePointDetail.vue?vue&type=style&index=0&id=4414f044&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4414f044",
  null
  
)

export default component.exports